// Utilidad para manejo de notificaciones/toasts
// Puedes integrar con librerías como Toastify, SweetAlert2, etc.

class ToastService {
  constructor() {
    // Aquí puedes inicializar tu librería de toasts preferida
    // Por ejemplo: import { toast } from 'vue3-toastify'
  }

  success(message, options = {}) {
    this.show(message, 'success', options)
  }

  error(message, options = {}) {
    this.show(message, 'error', options)
  }

  warning(message, options = {}) {
    this.show(message, 'warning', options)
  }

  info(message, options = {}) {
    this.show(message, 'info', options)
  }

  show(message, type = 'info', options = {}) {
    // Implementación básica con alert - puedes cambiar por tu librería favorita
    const config = {
      duration: 3000,
      position: 'top-right',
      ...options
    }

    // Si estás usando vue3-toastify:
    // toast[type](message, config)
    
    // Si estás usando SweetAlert2:
    // Swal.fire({ text: message, icon: type, ...config })
    
    // Implementación básica temporal:
    if (typeof window !== 'undefined') {
      // Crear elemento de toast
      const toast = this.createToastElement(message, type)
      document.body.appendChild(toast)
      
      // Auto-remove después del tiempo especificado
      setTimeout(() => {
        if (toast.parentNode) {
          toast.parentNode.removeChild(toast)
        }
      }, config.duration)
    }

    // Fallback para desarrollo
    console.log(`[${type.toUpperCase()}]: ${message}`)
  }

  createToastElement(message, type) {
    const toast = document.createElement('div')
    toast.className = `toast toast-${type}`
    toast.style.cssText = `
      position: fixed;
      top: 20px;
      right: 20px;
      padding: 12px 20px;
      border-radius: 4px;
      color: white;
      font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
      font-size: 14px;
      z-index: 10000;
      max-width: 350px;
      box-shadow: 0 4px 12px rgba(0,0,0,0.15);
      opacity: 0;
      transform: translateX(100%);
      transition: all 0.3s ease;
    `

    // Colores según el tipo
    const colors = {
      success: '#10b981',
      error: '#ef4444',
      warning: '#f59e0b',
      info: '#3b82f6'
    }
    
    toast.style.backgroundColor = colors[type] || colors.info
    toast.textContent = message

    // Animación de entrada
    setTimeout(() => {
      toast.style.opacity = '1'
      toast.style.transform = 'translateX(0)'
    }, 100)

    return toast
  }

  // Método para limpiar todos los toasts
  clear() {
    if (typeof window !== 'undefined') {
      const toasts = document.querySelectorAll('.toast')
      toasts.forEach(toast => {
        if (toast.parentNode) {
          toast.parentNode.removeChild(toast)
        }
      })
    }
  }
}

// Crear instancia singleton
const Toast = new ToastService()

export { Toast }
export default ToastService
